import { EventBus } from 'v2/utils/event-bus'

export const EvalEvents = {
  STARTED: 'eval:started',
  DATASET_GENERATION_STARTED: 'eval:dataset_generation_started',
  DATASET_GENERATION_STARTED_NODE: 'eval:dataset_generation_started_node',
  DATASET_GENERATION_COMPLETED: 'eval:dataset_generation_completed',
  DATASET_GENERATION_TEST_CASE: 'eval:dataset_generation_test_case',
  RESULT: 'eval:evaluation_result',
  COMPLETED: 'eval:completed',
  CANCELLED: 'eval:cancelled',
  TESTS_STARTED_FOR_NODE: 'eval:evaluation_tests_started_for_node',
  NODE_EVALUATION_SKIPPED: 'eval:node_evaluation_skipped',
  NODE_QUEUED: 'eval:node_queued',
  ERROR: 'eval:error',
  STREAM_ENDED: 'eval:stream_ended',
} as const

type EvalEventPayload = unknown

export type EvalEventName = (typeof EvalEvents)[keyof typeof EvalEvents]

export interface EvalEventsPayload {
  [EvalEvents.STARTED]: (payload: EvalEventPayload) => void
  [EvalEvents.DATASET_GENERATION_STARTED]: (payload: EvalEventPayload) => void
  [EvalEvents.DATASET_GENERATION_STARTED_NODE]: (payload: EvalEventPayload) => void
  [EvalEvents.DATASET_GENERATION_COMPLETED]: (payload: EvalEventPayload) => void
  [EvalEvents.DATASET_GENERATION_TEST_CASE]: (payload: EvalEventPayload) => void
  [EvalEvents.RESULT]: (payload: EvalEventPayload) => void
  [EvalEvents.COMPLETED]: (payload: EvalEventPayload) => void
  [EvalEvents.CANCELLED]: (payload: EvalEventPayload) => void
  [EvalEvents.TESTS_STARTED_FOR_NODE]: (payload: EvalEventPayload) => void
  [EvalEvents.NODE_EVALUATION_SKIPPED]: (payload: EvalEventPayload) => void
  [EvalEvents.NODE_QUEUED]: (payload: EvalEventPayload) => void
  [EvalEvents.ERROR]: (error: unknown) => void
  [EvalEvents.STREAM_ENDED]: () => void
}

export const evalEventBus = new EventBus<EvalEventsPayload>()
